import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

const _ = { debounce };

function DebouncedFilterInput({ value, onChange, placeholder, className, divStyle, hideSearchIcon, focusFindPlayer, 'data-testid': dataTestId }) {
    const [query, setQuery] = useState(value);
    const filterRef = useRef(null);
    const delayedQuery = _.debounce(q => onChange(q), 500);

    const handleChange = e => {
        setQuery(e.target.value);
        delayedQuery(e.target.value);
    };
    const resetFilter = () => {
        setQuery('');
        onChange('');
    };

    useEffect(() => {
        if (focusFindPlayer) {
            filterRef?.current?.focus();
        }
    }, [focusFindPlayer]);

    return (
        <div className="filter-wrapper" style={divStyle}>
            {!hideSearchIcon && <i className={`uts uts-search`} />}
            <input type="text" placeholder={placeholder} ref={filterRef} value={query} onChange={handleChange} className={className} data-testid={dataTestId && `${dataTestId}.input`} />
            <i className={`uts uts-close  ${query ? 'd-block' : 'd-none'} bg-white pl2`} style={{ paddingRight: '10px' }} onClick={resetFilter} data-testid={dataTestId && `${dataTestId}.clear-btn`} />
        </div>
    );
}

DebouncedFilterInput.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    divStyle: PropTypes.objectOf(PropTypes.any),
    hideSearchIcon: PropTypes.bool,
    focusFindPlayer: PropTypes.bool,
    'data-testid': PropTypes.string,
};

DebouncedFilterInput.defaultProps = {
    value: '',
    placeholder: '',
    className: '',
    divStyle: {},
    hideSearchIcon: false,
    focusFindPlayer: false,
    'data-testid': undefined,
};

export default DebouncedFilterInput;
